import { render, staticRenderFns } from "./InfoWidgets.vue?vue&type=template&id=0560ca28&scoped=true"
import script from "./InfoWidgets.vue?vue&type=script&lang=js"
export * from "./InfoWidgets.vue?vue&type=script&lang=js"
import style0 from "./InfoWidgets.vue?vue&type=style&index=0&id=0560ca28&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0560ca28",
  null
  
)

export default component.exports